import {RouteRecordRaw} from 'vue-router';
import Settings from '@/views/Settings.vue';
import Dashboard from "@/views/Dashboard.vue";
import Bookings from "@/views/Bookings.vue";
import Clients from "@/views/Clients.vue";
import ClientDetails from "@/views/ClientDetails.vue";
import Slots from "@/views/Slots.vue";
import Promocodes from "@/views/Promocodes.vue";
import Appointments from "@/views/Appointments.vue";

export const routes: Readonly<RouteRecordRaw[]> = <RouteRecordRaw[]>[
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard
    },
    {
        path: '/appointments',
        name: 'Appointments',
        component: Appointments
    },
    {
        path: '/clients',
        name: 'Clients',
        component: Clients
    },
    {
        path: '/clients/:id',
        name: 'ClientDetails',
        component: ClientDetails
    },
    {
        path: '/slots',
        name: 'Slots',
        component: Slots
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings
    },
    {
        path: '/promocodes',
        name: 'Promocodes',
        component: Promocodes
    }
];
